import React from 'react';
import { Code2, Twitter, Linkedin, Github } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-16 px-6 bg-[#050812] border-t border-gray-800/50">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center">
                <Code2 className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-bold text-white">SystemCraft</span>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Learn system design by building real systems. Practice with real constraints, not just theory.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Product</h4>
            <ul className="space-y-3">
              <li>
                <a href="#demo" className="text-gray-400 hover:text-cyan-400 transition-colors">
                  Watch Demo
                </a>
              </li>
              <li>
                <a href="#waitlist" className="text-gray-400 hover:text-cyan-400 transition-colors">
                  Join Waitlist
                </a>
              </li>
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="text-white font-semibold mb-4">Ready to Start?</h4>
            <p className="text-gray-400 mb-4">
              Join engineers preparing for their next system design interview.
            </p>
            <a
              href="#waitlist"
              className="inline-block px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-medium rounded-lg transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/50"
            >
              Get Early Access
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-gray-800/50 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} SystemCraft by VNC Labs. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://twitter.com/chandansgowdru"
              className="w-9 h-9 bg-gray-800 hover:bg-gray-700 rounded-lg flex items-center justify-center transition-colors group"
              aria-label="Twitter"
            >
              <Twitter className="w-4 h-4 text-gray-400 group-hover:text-cyan-400" />
            </a>
            <a
              href="https://www.linkedin.com/in/chandan-s-gowda-4b2913183/"
              className="w-9 h-9 bg-gray-800 hover:bg-gray-700 rounded-lg flex items-center justify-center transition-colors group"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-4 h-4 text-gray-400 group-hover:text-cyan-400" />
            </a>
            <a
              href="https://github.com/chandansgowda"
              className="w-9 h-9 bg-gray-800 hover:bg-gray-700 rounded-lg flex items-center justify-center transition-colors group"
              aria-label="GitHub"
            >
              <Github className="w-4 h-4 text-gray-400 group-hover:text-cyan-400" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
